module.exports = __webpack_public_path__ + "img/logo_pracevit.fa6de90.svg";